import { Lock } from "lucide-react";

/** Approved AE-207 copy for fields only an admin or district leader can change. */
export const LOCKED_FIELD_HINT = "Contact your admin or district leader to change this.";

export const ProfileField = ({
  label,
  value,
  locked = false,
  badge,
}: {
  label: string;
  value?: string | null;
  locked?: boolean;
  badge?: string;
}) => (
  <div className="border-b border-gray-100 pb-4 last:border-b-0 last:pb-0">
    <p className="font-inter text-xs uppercase tracking-wide text-gray-500">{label}</p>

    <div className="mt-1 flex flex-wrap items-center gap-2">
      <p className="font-inter text-base text-gray-900">{value?.trim() ? value : "—"}</p>
      {badge && (
        <span className="rounded-full border border-bodhi-gold/60 px-2 py-0.5 font-inter text-xs text-bodhi-gold">
          {badge}
        </span>
      )}
    </div>

    {locked && (
      <p className="mt-1.5 flex items-center gap-1.5 font-inter text-xs text-gray-500">
        <Lock className="h-3 w-3 shrink-0" aria-hidden />
        {LOCKED_FIELD_HINT}
      </p>
    )}
  </div>
);
